// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "85cee968d3bd2490670daea2aeca3c46df1b0ca0/scripts/" + chunkId + ".js";
};